<div
	uiDropdown
	[ignoreTrigger]="searchOpen()"
	(openChange)="onDropdownStateChange($event)"
	data-cy="c-vehicle-union-select"
	[fullWidth]="fullWidth()"
>
	<div
		uiDropdownTrigger
		[uiDropdownDisabled]="isDisabled()"
		class="flex gap-0.5 w-full"
		data-cy="c-vehicle-union-select-dropdown-trigger"
	>
		@if (searchOpen()) {
			<ui-input
				type="search"
				class="w-full h-10 z-select-search"
				[value]="searchText()"
				(valueChanged)="searchText.set($event)"
				[placeholder]="'general.search' | translate"
				#searchInput
			/>
		} @else {
			<div
				class="flex rounded bg-standard cursor-pointer h-10 w-full border border-secondary-300 py-px px-3 items-center justify-between outline-hidden"
				[ngClass]="{
					'bg-secondary-100! color-secondary-400 cursor-not-allowed!': isDisabled(),
				}"
				tabindex="0"
			>
				@if (value()?.length) {
					<div class="flex justify-between w-full items-center gap-2">
						<span class="line-clamp-1">
							{{ value()[0].name }} ({{ value()[0].serial }}) |
							{{ value()[0].union }}
						</span>

						<div class="flex items-center">
							@if (value().length > 1) {
								<ui-pill
									[value]="'+' + (value().length - 1).toString()"
									class="mr-1"
									type="secondaryFilled"
								></ui-pill>
							}
						</div>
					</div>
				} @else {
					<span class="text-secondary-400 line-clamp-1">
						{{ 'select.placeholder' | translate }}
					</span>
				}
				<ui-icon
					icon="x_arrow_down"
					class="transition block"
					[ngClass]="dropdownOpen() ? 'rotate-180' : ''"
					size="m"
				></ui-icon>
			</div>
		}
	</div>

	@let currentSelectedUnion = currentSelectedUnion$ | async;

	@if (
		vehicleResponse$
			| async
			| vehicleSelectOption: currentSelectedUnion : userRole() : selectedCount() > 0;
		as groups
	) {
		<div *uiDropdownContent class="flex flex-col">
			<div
				class="max-h-64"
				[ngClass]="loadingVehicles() ? 'overflow-hidden' : 'overflow-y-auto'"
				#optionsList
				(scroll)="onScroll()"
			>
				@if (groups.length === 0 && !loadingVehicles()) {
					<div class="p-4 pb-2">
						<ui-notify [text]="'general.no_data' | translate"></ui-notify>
					</div>
				}
				@if (!loadingVehicles()) {
					@for (group of groups; track group.uuid) {
						@if (currentSelectedUnion === group.uuid) {
							<union-select-option
								[union]="group.name"
								[options]="group.options"
								[selectedVehicles]="selectedVehicles()"
								[role]="userRole()"
								(deselectAll)="onDeselectAll()"
								(selectAll)="onSelectAllInUnion(group.uuid)"
								id="selected-union-header"
								data-cy="c-vehicle-union-select-selected-union-header"
							></union-select-option>
						}
						@for (vehicle of group.options; track vehicle.value) {
							<vehicle-select-option
								[displayPills]="displayPills()"
								[displayVehicleModel]="displayVehicleModel()"
								[option]="vehicle"
								[selected]="isVehicleSelected(vehicle.value)"
								(selectWholeUnion)="onSelectAllInUnion(group.uuid)"
								[unionSelected]="!!currentSelectedUnion"
								(toggleItem)="onSelect($event)"
								[role]="userRole()"
							></vehicle-select-option>
						}
					}
				}

				@if (loadingVehicles()) {
					<div class="w-full h-10">
						<ui-spinner [inline]="true" [size]="'s'"></ui-spinner>
					</div>
				}
			</div>

			@if (hasExceededMaxSelections()) {
				<div class="pl-3 pr-3 absolute bottom-10 w-full">
					<ui-notify
						[text]="maxSelectedVehiclesText() | translate: { max: maxSelections() }"
						type="warning"
					></ui-notify>
				</div>
			}

			<div class="flex items-center border-t border-secondary-300 h-10 w-full justify-center">
				@if (displayDeselectAll() && selectedCount() > 0) {
					<div
						class="flex items-center text-secondary-800 cursor-pointer text-sm p-2 user-select-none justify-center w-full"
						(click)="onDeselectAll()"
						[ngClass]="loadingVehicles() ? 'text-secondary-400! cursor-not-allowed!' : ''"
						data-cy="c-vehicle-union-select-button-deselect-all"
					>
						{{ 'select.deselect_all' | translate }}
					</div>
				}
				<div
					class="flex items-center h-full text-sm p-2 user-select-none justify-center w-full"
					[class]="
						isDisabledStyle()
							? 'text-secondary-400 cursor-not-allowed'
							: 'bg-primary-700 text-white dark:text-secondary-800 hover:bg-primary-900 cursor-pointer'
					"
					tabindex="0"
					(click)="onSave()"
					(keydown.enter)="onSave()"
					data-cy="c-vehicle-union-select-button-save"
				>
					{{ 'general.save' | translate }}

					<span class="ml-1">({{ selectedCount() }})</span>
				</div>
			</div>
		</div>
	}
</div>
